import { render, staticRenderFns } from "./PageFourView.vue?vue&type=template&id=67071809"
import script from "./PageFourView.vue?vue&type=script&lang=js"
export * from "./PageFourView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports